import { IDataDriver } from "../types";
import { IAnyObj } from "@dhx/ts-common/types";

export class JsonDriver implements IDataDriver {
	toJsonArray(data: any) {
		return this.getRows(data);
	}
	serialize(data: IAnyObj[]): IAnyObj[] {
		return data;
	}
	getFields(row: any): { [key: string]: any } {
		return row;
	}
	getRows(data: string): any[] {
		return typeof data === "string" ? JSON.parse(data) : data;
	}
}